import axios from 'axios'

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('jwt-token')
  config.headers.Authorization = token

  return config
})

export const apiRequest = (method, endpoint, data, headers, params) => {
  return axios({
    method,
    url: endpoint,
    data,
    headers,
    params
  })
  .then(response => {
    return response.data
  })
  .catch(error => {
    if (error.response) {
      if (error.response.status === 401) {
        window.location.assign('/auth/login?redirectPath=' + window.location.pathname)
      } else if (error.response.status >= 500) {
        window.location.assign('/beneficiary/error/' + error.response.status)
      } else if (error.response.status === 403) {
        if(error.response.data === 'cgu.approval') {
          window.location.assign('/beneficiary/cgu')
        } else {
          window.location.assign('/beneficiary/error/' + error.response.status)
        }
      } else {
        console.error(error)
        window.location.assign('/manager/error/520')
      }
    }
  })
}

export const graphqlRequest = (query) => {
  return apiRequest('POST', '/beneficiary-api/graphql/v1', { query })
}

export const getContactReference = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/contactReference')
}
export const getBabysittingModes = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/babysittingModes')
}
export const getAgeCategories = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/ageCategories')
}
export const getSituationFamily = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/situationFamily')
}
export const getSituationFamilySingleParent = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/situationFamilySingleParent')
}
export const getFaqs = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/faqs')
}
export const getCommune = (cp) => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/commune', {}, {}, { cp })
}
export const getBenefitAmountsQuery = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/benefitAmounts')
}

export const getEmployee = (employeeFields) => {
  return graphqlRequest(`
  {
    getEmployee {
      ${ employeeFields }
    }
  }
  `)
}

export const updateEmployeeQuery = (employeeInput, employeeFields) => {
  return graphqlRequest(`
    mutation {
      updateEmployee(employeeInput: {
        ${ employeeInput }
      }){
        ${ employeeFields }
      }
    }
  `)
}

export const checkSimulation = (simulation, simulationOnly) => {
  return graphqlRequest(`
  {
    benefitSimulation(benefitSimulationInput: {
      ${ simulation.singleParent ? 'singleParent: true' : '' }
      ${ simulation.childSupport ? `childSupportAnnualAmount:${ simulation.childSupport }` : '' }
      ${ (simulation.partnerIncome || simulation.partnerIncome === 0) ? `partnerAnnualNetIncome: ${ simulation.partnerIncome }` : '' }
      ${ simulation.nbChildren ? `nbChildren: ${ simulation.nbChildren }` : '' }
    }
    simulationOnly: ${ simulationOnly }) {
      eligible
    }
  }`)
}

export const getAttachmentConfig = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/attachment-config')
}

export const checkJwt = () => {
  return apiRequest('GET', '/auth/check')
}

export const getRecordAttachmentConfig = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/record-attachment-config')
}

export const getDeclarationAttachmentConfig = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/declaration-attachment-config')
}

export const getCgu = () => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/cgu')
}

export const getConsentLabel = (labelKey) => {
  return apiRequest('GET', '/beneficiary-api/rest/v1/consentLabel', {}, {}, { key: labelKey })
}

export const getConsentLabels = (labelKeys) => {
  return apiRequest('POST', '/beneficiary-api/rest/v1/consentLabels', { keys: labelKeys })
}

export const approveCgu = () => {
  return graphqlRequest(`
    mutation {
      approveCgu
    }
  `)
}

export const getNotifications = () => {
  return graphqlRequest(`
  {
    getNotifications {
      _id
      createdDate
      childName
      babysittingMode
      title
    }
  }
  `)
}

export const getNotificationDetail = (_id) => {
  return graphqlRequest(`
  {
    getNotification(_id: "${ _id }") {
      _id
      createdDate
      childName
      babysittingMode
      title
      message
    }
  }
  `)
}


export const deleteNotification = (_id) => {
  return graphqlRequest(`
  mutation {
    deleteNotification(_id: "${ _id }")
  }
  `)
}

export const sendContactMessage = (contactMessage) => {
  return graphqlRequest(`
  mutation {
    sendContactMessage(contactMessage: {` + Object.keys(contactMessage).map(key => `${ key }: "${ contactMessage[key] }"`).join(' ') + `})
  }
  `)
}

export function getConsentReapprovedMessage() {
  return apiRequest('GET', '/beneficiary-api/rest/v1/consentReapprovedMessage')
}

export const approveConsent = () => {
  return graphqlRequest(`
    mutation {
      approveConsent
    }
  `)
}

export function incrementConnection() {
  return graphqlRequest(`
    mutation {
      connectionStatistic
    }
  `)
}

export function incrementStatistic(type, key) {
  return graphqlRequest(`
    mutation {
      incrementStatistic(
        type: ${ type }
        ${ key ? `key: "${ key }"` : ''}
      )
    }
  `)
}

export function getInitConfig() {
  return apiRequest('GET', '/beneficiary-api/rest/v1/init-config')
}
